import { Asset } from 'app/shared/collections/asset';
import { FieldSchemaUnits } from 'app/shared/collections/StatDefinition';
import { Operator } from 'app/shared/operators';
import { IMSAggregator } from 'app/views/aggregators/aggregator';
import { IMSValueGetter, StatFilterFnGenerator } from 'app/views/value_getters/value_getter';

// This class needs to override a bit of functionality in the base value getter -
// specifically how the base value getter always looks for stats on ip devices.
export class GenericAssetStatValueGetter extends IMSValueGetter {
    constructor(
        statCollection,
        statKey,
        units: FieldSchemaUnits,
        operators: Operator[],
        filterFunctionGenerator: StatFilterFnGenerator = null,
    ) {
        super(statCollection, statKey, units, filterFunctionGenerator, [], operators);
    }

    getValueForStat(stat) {
        if (!stat) {
            return undefined;
        }

        if (stat.resource) {
            return stat.resource[this.statKey];
        }

        return stat[this.statKey];
    }

    /**
     * Takes an asset and a cesium time and returns a value
     *
     * @param asset An Asset object (IMS Asset, not Cesium Entity)
     * @param time Cesium JulianDate object
     * @param aggregator IMSAggregator
     * @returns a number or string value
     */
    getValueForAsset(asset: Asset, time: Cesium.JulianDate, aggregator: IMSAggregator) {
        const stats = this._getStatForAsset(asset, time);

        if (!aggregator) {
            throw new Error('must provide an aggregator');
        }

        return aggregator.getAggValueForStatArray(stats, this);
    }

    // Always returns an array of size 1
    _getStatForAsset(asset: Asset, time: Cesium.JulianDate): object[] {
        if (!asset) {
            return undefined;
        }
        return this.statCollection.getStats(asset.id, time);
    }
}
